import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { AgoraConfigService } from 'src/AgoraConfigService';
import { AttachmentService } from 'src/app/service/attachment.service';
import { environment, environment_const, environment_label, environment_msg } from 'src/environments/environment';


@Component({
  selector: 'app-preview-attachment',
  templateUrl: './preview-attachment.component.html',
  styleUrls: ['./preview-attachment.component.css']
})
export class PreviewAttachmentComponent implements OnInit {
  collaboraUrl: any;
  downloadURL: any
  element: any;
  selectedFileBLOB: any;
  type: "";
  check = false;
  spinner: boolean = false;
  content: any;
  title: any;
  pdfSrc?: SafeResourceUrl;
  fileId: any;
  accessToken: any;
  unSafeUrl: any;
  loginName: any;
  agoraConfigObject: any;

  constructor(@Inject(MAT_DIALOG_DATA) data: any, private sanitizer: DomSanitizer, private dialogRef: MatDialogRef<PreviewAttachmentComponent>, public attachService: AttachmentService, private spin: NgxSpinnerService, private agoraConfig: AgoraConfigService) {
    this.fileId = data.fileId;
    this.type = data.type;
    this.title = data.title;
    this.accessToken = localStorage.getItem('token');
    this.loginName = localStorage.getItem('encLoginName');
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;

    // this.unSafeUrl = environment.collaboraURL +this.fileId + "&access_token=" + this.accessToken;
    this.unSafeUrl = `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.collaboraURL}` + this.fileId + "&access_token=" + this.accessToken;
    this.collaboraUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.unSafeUrl);
  }


  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close();
  }


  loading() {

    this.spinner = true
  }
  hide() {

    this.spinner = false
  }
  failed() {

    this.spinner = false
  }

  download() {

    const a = document.createElement('a');
    a.href = this.downloadURL;
    var extension = this.title.split('.').pop();
    var filename = this.title.split('/').pop().split('.')[0];
    a.download = filename + '.' + extension;
    a.click();
    window.URL.revokeObjectURL(this.downloadURL);
  }
  convertBlobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.onloadend = () => resolve(reader.result as ArrayBuffer);
      reader.onerror = reject;
    });

  }

  downloadAttachment() {
    this.spin.show();

    this.attachService.getAttachmentById(this.fileId).subscribe((data: any) => {
      this.spin.hide();
      const fileData = data
      const a = document.createElement('a');
      document.body.appendChild(a);
      const blob = new Blob([data.body], { type: data.body.type }),
        url = window.URL.createObjectURL(blob);
      a.href = url;
      var extension = this.title.split('.').pop();
      var filename = this.title.split('/').pop().split('.')[0];
      a.download = filename + '.' + extension;
      a.click();
      window.URL.revokeObjectURL(url);
    })
  }

}
